import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { StyleGuideCreateInput, StyleGuideCreatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = StyleGuideCreateInput;
type TData = StyleGuideCreatePayload;

export const useStyleGuideCreate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation styleGuideCreate($input: StyleGuideCreateInput!) {
      styleGuideCreate(input: $input) {
        success
        errors
        errorCode

        styleGuide {
          id
          name
          referenceId
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
